import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TableComponent} from '../../../../components/table/table.component';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {IfHasAllPermissionsDirective} from '../../../../directives/if-has-all-permissions.directive';
import {PERMISSION} from '@generated-backend-types';

@Component({
  selector: 'app-authenticated-quality-management-processes-index',
  templateUrl: './index.component.html',
  imports: [TableComponent, RouterLink, TranslatePipe, IfHasAllPermissionsDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  protected readonly PERMISSION = PERMISSION;

  public ngOnInit() {
    this.titleService.setTitle('authenticated.quality-management.processes.index.title');
  }
}
